import React from "react";
import "./gallery.css";
import Art from "./Art.js";

//Preventing right-click > save Image (I know they can just do printScreen, but that is in low res)
//document.addEventListener('contextmenu', event => event.preventDefault());

class Gallery extends React.Component {
    constructor(props) {
        super(props);

        this.createArtworkArray = this.createArtworkArray.bind(this);
    };

    createArtworkArray() {
        const json = require("./artwork.json");
        console.log(json);
        //let artArray = json.map(eachItem => {return eachItem});
        return json;
    };


    render() {
        let artArray = this.createArtworkArray();
        console.log("This is artArray " + JSON.stringify(artArray.Artwork[0].name));
        return(

            <div id="gallery">
                <img id="splash" src="./images/indexSplashHD.jpg" alt="Closeup of sanding marquetry artwork" />
                <img className="arrow" src="./images/misc/arrowDown.gif" alt="Cue to scroll down for more content." />
                <div className="galleryBackground">
                    <div id="textContent">No stains used ~ Only natural exotic woods</div>
                </div>
                <div className="artContainer">
                    {artArray.Artwork.map(eachArt => {return <Art eachArt={eachArt} key={eachArt.id} />})}
                </div>
                <footer className="footer">

                </footer>
            </div>
        );
    };
};

export default Gallery;